import { NodeSelection, TextSelection } from '@atlaskit/editor-prosemirror/state';
import { findParentNodeOfType, hasParentNodeOfType } from '@atlaskit/editor-prosemirror/utils';

// function to check whether the selected node is the sole decision item in the decision list
var isSelectedNodeSoleDecisionItem = function isSelectedNodeSoleDecisionItem(state) {
  var _findParentNodeOfType;
  var isDecisionItemNodeSelected = state.selection instanceof NodeSelection && state.selection.node.type.name === 'decisionItem';
  if (!isDecisionItemNodeSelected) {
    return false;
  }
  var decisionList = (_findParentNodeOfType = findParentNodeOfType([state.schema.nodes.decisionList])(state.selection)) === null || _findParentNodeOfType === void 0 ? void 0 : _findParentNodeOfType.node;
  return (decisionList === null || decisionList === void 0 ? void 0 : decisionList.childCount) === 1;
};
var isSelectedNodeMediaGroup = function isSelectedNodeMediaGroup(state) {
  return Boolean(state.selection instanceof NodeSelection && state.selection.node.type.name === 'media' && state.selection.$head.parent.type.name === 'mediaGroup');
};

/**
 * Prevent removing the block when deleting block content
 *
 * @param state EditorState
 * @param dispatch CommandDispatch
 * @returns boolean
 */
export function deleteBlockContent(isNodeAWrappingBlockNode) {
  return function (state, dispatch) {
    var tr = state.tr,
      _state$selection = state.selection,
      $from = _state$selection.$from,
      $to = _state$selection.$to,
      doc = state.doc;
    if ($from.pos === $to.pos) {
      return false;
    }
    var selectionCrossesWrappingBlockNode = false;
    doc.nodesBetween($from.pos, $to.pos, function (node, pos) {
      // Optimisation. If selection crosses wrapping block node
      // short circuit the loop by returning false
      if (isNodeAWrappingBlockNode(node)) {
        selectionCrossesWrappingBlockNode = true;
        return false;
      }
    });
    if (!selectionCrossesWrappingBlockNode) {
      return false;
    }
    var isParentNodeOfTypePanel = hasParentNodeOfType([state.schema.nodes.panel])(state.selection);

    // If decision is inside panel and the decision list have only one decision item which is selected,
    // delete the whole decision list.
    // Also, checks if selection is a mediaGroup node within a panel
    if (isParentNodeOfTypePanel && (isSelectedNodeSoleDecisionItem(state) || isSelectedNodeMediaGroup(state))) {
      tr.setSelection(new TextSelection(tr.doc.resolve($from.before()))).delete($from.before(), $from.after());
    } else {
      tr.delete($from.pos, $to.pos);
    }
    if (dispatch) {
      dispatch(tr);
    }
    return true;
  };
}